import { Type } from '@sinclair/typebox';
export const GardenFavoriteInput = Type.Object({
    attachmentId: Type.String({ minLength: 1, maxLength: 100 }), selected: Type.Boolean(),
}, { additionalProperties: false });
export const GardenLayoutInput = Type.Object({
    bench: Type.Union([Type.Literal('left'), Type.Literal('center'), Type.Literal('right')]),
    path: Type.Union([Type.Literal('stones'), Type.Literal('gravel'), Type.Literal('none')]),
    plant: Type.Union([Type.Literal('lavender'), Type.Literal('sunflower'), Type.Literal('fern')]),
    expectedRevision: Type.Integer({ minimum: 0 }),
}, { additionalProperties: false });
//# sourceMappingURL=garden.js.map